package org.zq.astrock_ai.api

/**
 * 荐股持有周期 / 玩法：
 * - overnight：今买明日卖（含经典隔夜 + 次日上涨路径，早盘或尾盘出场）
 * - swing：中线 3–6 个月
 *
 * API：`style=overnight|swing`
 */
object RecommendStyle {
    const val OVERNIGHT = "overnight"
    const val SWING = "swing"

    fun parse(raw: String?): String {
        val t = raw.orEmpty().trim().lowercase()
        return when (t) {
            OVERNIGHT, "隔夜", "短线", "今买明早卖", "今买明日卖", "今天买明天卖",
            // 旧「次日涨停」及「次日上涨」别名并入隔夜
            "limithunt", "zt", "zthunt", "seal", "nextdayup", "次日涨停", "次日上涨",
            "涨停博弈", "涨停猎手", "打板前置",
            -> OVERNIGHT
            SWING, "mid", "中线", "波段", "3-6", "3～6", "持有" -> SWING
            else -> OVERNIGHT
        }
    }

    fun isSwing(raw: String?): Boolean = parse(raw) == SWING
    fun isOvernight(raw: String?): Boolean = parse(raw) == OVERNIGHT

    fun label(raw: String?): String = when (parse(raw)) {
        OVERNIGHT -> "隔夜短线"
        else -> "中线3–6个月"
    }

    /** 隔夜出场口径：明日清仓，早盘或尾盘均可 */
    fun overnightExitHint(): String =
        "明日必须清仓：弱开/低开优先早盘走；开盘偏强可拿到午后或尾盘（约14:30–14:50）分批兑现；不隔第二夜"

    /** 次日上涨路径补充纪律（并入隔夜结果时展示） */
    fun limitHuntExitHint(): String =
        "若属次日上涨路径：不问今日阴阳，只赌次日收阳；破5日线者须缩量+洗盘/板块且更轻仓；弱开/低开立刻走；冲高回落减仓；无论盈亏务必当日清仓，不隔第二夜"
}
